module.exports = __webpack_public_path__ + "img/marker_primary.2d89cb6c.svg";